import { render, staticRenderFns } from "./infoFormEdit.vue?vue&type=template&id=55ca27f0&scoped=true"
import script from "./infoFormEdit.vue?vue&type=script&lang=js"
export * from "./infoFormEdit.vue?vue&type=script&lang=js"
import style0 from "./infoFormEdit.vue?vue&type=style&index=0&id=55ca27f0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ca27f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55ca27f0')) {
      api.createRecord('55ca27f0', component.options)
    } else {
      api.reload('55ca27f0', component.options)
    }
    module.hot.accept("./infoFormEdit.vue?vue&type=template&id=55ca27f0&scoped=true", function () {
      api.rerender('55ca27f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/merchantsettlement/infoFormEdit.vue"
export default component.exports